export const appTypes = {
  SET_ACTIVE_PANEL: "SET_ACTIVE_PANEL",
  SET_ACTIVE_MODAL: "SET_ACTIVE_MODAL",
  SET_USER: "SET_USER",
  REQUEST: "REQUEST",
  GET_TRIPS: "GET_TRIPS",
};
